import { render, staticRenderFns } from "./CustomOfferDetailsView.vue?vue&type=template&id=5a8d17f8&scoped=true"
import script from "./CustomOfferDetailsView.vue?vue&type=script&lang=ts"
export * from "./CustomOfferDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./CustomOfferDetailsView.vue?vue&type=style&index=0&id=5a8d17f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8d17f8",
  null
  
)

export default component.exports